<template>
  <div class="subscription-required">
    <KeyIcon class="subscription-required__icon" />
    <p class="subscription-required__notice">
      {{ unSubscribedText }}
    </p>
    <a
      :href="unSubscribedTLink"
      target="_blank"
      rel="noopener"
      class="btn btn--primary"
      >{{ unSubscribedTCTA }}</a
    >
  </div>
</template>

<script>
import KeyIcon from '@/assets/icons/course/key_icon.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'SubscriptionRequired',
  components: {
    KeyIcon: { ...KeyIcon, name: 'KeyIcon' },
  },
  props: {
    plansLink: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: false,
      default: () => CONSTANTS.PARENT_CONTENT_TYPES_KEYS.COURSE,
    },
    contentId: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  computed: {
    isLabExperiencePath() {
      return (
        this.contentType ===
          CONSTANTS.PARENT_CONTENT_TYPES_KEYS.LEARNING_PATH &&
        Object.values(CONSTANTS.SPECIAL_LEARNING_PATHS).includes(this.contentId)
      )
    },
    unSubscribedText() {
      if (this.isLabExperiencePath) {
        return `This content is part of INE's new Lab Experience. Learn more to get exclusive access to the world's best lab experience.`
      }
      return 'Get Access to this Content with an INE Subscription'
    },
    unSubscribedTCTA() {
      if (this.isLabExperiencePath) {
        return 'Learn more'
      }
      return 'Get Started'
    },
    unSubscribedTLink() {
      if (this.isLabExperiencePath) {
        return '//info.ine.com/lab-experience/'
      }
      return `//${this.plansLink}`
    },
  },
}
</script>

<style lang="scss">
.subscription-required {
  display: flex;
  align-items: center;
  &__notice {
    font-size: 14px;
    color: var(--white);
    margin: 0 15px 0 0;
    font-family: var(--font-bold);
  }
  &__icon {
    margin: 0 15px 0 0;
  }
}
</style>
